<template>
    <div>
        <div class="administracion-equipos">
            <RejillaOscilos :oscilosProp="dxDataGridSource" :vistaAdministracionProp="true"
                @IdInstalacionChanged="onIdInstalacionChanged" @DxDataGridFilterChanged="onDxDataGridFilterChanged">
            </RejillaOscilos>
            <MapaOscilos ref="mapaOscilos" :oscilosProp="oscilos"
                :idInstalacionSeleccionadaProp="idInstalacionSeleccionada">
            </MapaOscilos>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, } from 'vue';
import { useRoute } from "vue-router";
import { useIntl } from '@services/i18n';
import type { LoadOptions } from 'devextreme/data';
import { useApi } from '@/.shared/.api/integration';
import type { OsciloDetalleModel } from '@/.shared/.api';
import MapaOscilos from '@/components/oscilos/MapaOscilos.vue';
import { useRouter } from '@/.shared/services/routing-services';
import RejillaOscilos from '@/components/oscilos/RejillaOscilos.vue';
import type CustomStore from 'devextreme/data/custom_store';
import type { LoadResult, LoadResultObject } from 'devextreme/common/data/custom-store';
const emit = defineEmits(['childViewLoaded']);

const api = useApi();
const intl = useIntl();
const route = useRoute();
const router = useRouter();
const idInstalacionSeleccionada = ref<number>();

const mapaOscilos = ref<typeof MapaOscilos>();
let dxDataGridSource: CustomStore;
const oscilos = ref<OsciloDetalleModel[]>([]);

onMounted(() => {
    emit('childViewLoaded', route.name);
});

dxDataGridSource = api.apiStore({ // para rejillas
    key: 'Id',
    load: await api.toStandardApiFunction('osciloGetRejilla', {}),
    onLoaded: (result: LoadResult<OsciloDetalleModel>, loadOptions: LoadOptions<OsciloDetalleModel>) => {
        if (loadOptions.group == null) {
            oscilos.value = (result as LoadResultObject<OsciloDetalleModel>).data as OsciloDetalleModel[];
        }
    }
});

function onIdInstalacionChanged(idInstalacion: number | undefined) {
    idInstalacionSeleccionada.value = idInstalacion;
}

function onDxDataGridFilterChanged() {
    mapaOscilos.value!.centerMap();
}
</script>


<style lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.administracion-equipos {
    display: grid;
    grid-gap: var(--spacing-md);
    grid-template-columns: 1fr 475px;
}

@media (max-width: 991px) {
    .administracion-equipos {
        grid-template-columns: 1fr;
    }

    .administracion-equipos>div:nth-child(2) {
        display: none;
    }
}
</style>